/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ environmentVariable: NonNullable<unknown> }} Components_App_Providers_Missing_Privy_HeadingInputs */

const en_components_app_providers_missing_privy_heading = /** @type {(inputs: Components_App_Providers_Missing_Privy_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Missing ${i?.environmentVariable}`)
};

const de_components_app_providers_missing_privy_heading = /** @type {(inputs: Components_App_Providers_Missing_Privy_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.environmentVariable} fehlt`)
};

const pt_br2_components_app_providers_missing_privy_heading = /** @type {(inputs: Components_App_Providers_Missing_Privy_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.environmentVariable} ausente`)
};

const tr_components_app_providers_missing_privy_heading = /** @type {(inputs: Components_App_Providers_Missing_Privy_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.environmentVariable} eksik`)
};

const zh_cn2_components_app_providers_missing_privy_heading = /** @type {(inputs: Components_App_Providers_Missing_Privy_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`缺少 ${i?.environmentVariable}`)
};

const zh_hk2_components_app_providers_missing_privy_heading = /** @type {(inputs: Components_App_Providers_Missing_Privy_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`缺少 ${i?.environmentVariable}`)
};

const ko_kr2_components_app_providers_missing_privy_heading = /** @type {(inputs: Components_App_Providers_Missing_Privy_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.environmentVariable} 없음`)
};

const ru_ru2_components_app_providers_missing_privy_heading = /** @type {(inputs: Components_App_Providers_Missing_Privy_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отсутствует ${i?.environmentVariable}`)
};

const es_419_components_app_providers_missing_privy_heading = /** @type {(inputs: Components_App_Providers_Missing_Privy_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falta ${i?.environmentVariable}`)
};

/**
* | output |
* | --- |
* | "Missing {environmentVariable}" |
*
* @param {Components_App_Providers_Missing_Privy_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_app_providers_missing_privy_heading = /** @type {((inputs: Components_App_Providers_Missing_Privy_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_App_Providers_Missing_Privy_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_app_providers_missing_privy_heading(inputs)
	if (locale === "de") return de_components_app_providers_missing_privy_heading(inputs)
	if (locale === "pt-BR") return pt_br2_components_app_providers_missing_privy_heading(inputs)
	if (locale === "tr") return tr_components_app_providers_missing_privy_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_components_app_providers_missing_privy_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_components_app_providers_missing_privy_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_components_app_providers_missing_privy_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_components_app_providers_missing_privy_heading(inputs)
	return es_419_components_app_providers_missing_privy_heading(inputs)
});